/*
 * @Description: 全局事件总线
 * @Author: ljrong
 * @Date: 2024-06-28 16:18:57
 * @LastEditors: ljrong jinrong.li@beautydata.ai
 * @LastEditTime: 2024-07-29 09:26:46
 */
import mitt from 'mitt'

export const events = {
  recommendClick: 'recommendClick',
  translateArticlePopup: 'translateArticlePopup',
  KnowledgeBaseLibLocalUploadSuccess: 'KnowledgeBaseLibLocalUploadSuccess',
  KnowledgeBaseLibRefresh: 'KnowledgeBaseLibRefresh',
  KnowledgeBaseSummaryPopover: 'KnowledgeBaseSummaryPopover',
  showSystemRenewalDialog: 'showSystemRenewalDialog',
  showAppAiQuoteDialog: 'showAppAiQuoteDialog', // 展示AI引用Dialog
  hideAppAiQuoteDialog: 'hideAppAiQuoteDialog', // 隐藏AI引用Dialog
  appAiQuotePopoverOutLinkClick: 'appAiQuotePopoverOutLinkClick', // AI引用Popover外链点击
  appAiQuoteScrollToPosition: 'appAiQuoteScrollToPosition', // AI引用滚动到指定位置
  closeActivityBanner: 'closeActivityBanner', // 关闭活动弹窗
}

export default mitt()
